import styled from "styled-components";

export const BenefitsSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.xxLarge} ${({ theme }) => theme.spacing.xLarge};
    margin: 0 auto;
    width: 100%;
`;

export const BenefitsCardsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxLarge};
    width: 100%;
    max-width: 400px;
`;

export const BenefitsRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.large};
    justify-content: center;
    flex-wrap: nowrap;
    overflow: hidden;
    min-width: 0;
    width: 100%;
`;

export const BenefitCard = styled.div`
    width: 150px;
    height: 217px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
`;

export const BenefitCardBackground = styled.div`
    position: absolute;
    left: 0;
    top: 70px;
    width: 100%;
    height: 157px;
    flex-shrink: 0;
    border-radius: 100px 100px 12px 12px;
    background: #C8F9E5;
`;

export const BenefitCardContent = styled.div`
    position: absolute;
    left: 0;
    top: 100px;
    width: 100%;
    height: 157px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    gap: ${({ theme }) => theme.spacing.xxSmall};
`;

export const BenefitCardTitle = styled.div`
    text-align: center;
`;

export const BenefitCardSubtitle = styled.div`
    text-align: center;
`;

export const BenefitIconWrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
    width: 118px;
    height: 118px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BenefitIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const TestimonialsSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xLarge};
    padding: ${({ theme }) => theme.spacing.xxLarge} ${({ theme }) => theme.spacing.xLarge};
    margin: 0 auto ${({ theme }) => theme.spacing.xxLarge};
    width: 100%;
`;

export const TestimonialsCardsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xLarge};
    overflow-x: scroll;
    width: 100%;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const TestimonialContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
`;

export const ProfileSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxSmall};
    width: 121px;
`;

export const ProfileImage = styled.img`
    width: 95px;
    height: 88px;
    border-radius: ${({ theme }) => theme.cornerRadius.halfRounded};
`;

export const GreenSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: linear-gradient(180deg, rgba(19, 98, 84, 1) 4%, rgba(90, 184, 88, 1) 62%);
    border-radius: 0 0 ${({ theme }) => theme.spacing.medium} ${({ theme }) => theme.spacing.medium};
    padding: ${({ theme }) => theme.spacing.xxLarge} ${({ theme }) => theme.spacing.xLarge};
    margin-top: ${({ theme }) => theme.spacing.xxLarge};
    gap: ${({ theme }) => theme.spacing.xxLarge};
`;

export const DividerWrapper = styled.div`
    width: 314px;
    height: 2px;
    position: relative;
    margin: 0 auto;
`;

export const GradientLine = styled.div`
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 82, 0, 0) 0%, rgba(255, 82, 0, 1) 50%, rgba(255, 82, 0, 0) 100%);
`;
